export const MaximumNoOfYearCount = 9;
export const creditCardBrands = [
    {
        "id": "VISA",
        "icon": "https://images.gyft.com/ucomm/visa_logo_2.gif",
        "cvvLength": 3,
        "validLengths": [16],
        "regex": "^(?:4[0-9]*)$",
        "subBrands": [
            {
                "id": "DANKORT_VISA",
                "icon": "https://images.gyft.com/ucomm/discover_logo_2.gif",
                "cvvLength": 3,
                "validLengths": [16],
                "binRanges": [
                    {
                        "min": "4571"
                    }
                ]
            }
        ]
    },
    {
        "id": "MASTERCARD",
        "icon": "https://images.gyft.com/ucomm/mastercard_logo_2.gif",
        "cvvLength": 3,
        "validLengths": [16],
        "regex": "^((?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]*)$",
        "subBrands": [
            {
                "id": "DINNERS_CLUB_MASTERCARD",
                "icon": "https://images.gyft.com/ucomm/discover_logo_2.gif",
                "cvvLength": 3,
                "validLengths": [16],
                "binRanges": [
                    {
                        "min": "54"
                    },
                    {
                        "min": "55"
                    }
                ]
            },
            {
                "id": "MAESTRO",
                "icon": "https://images.gyft.com/ucomm/discover_logo_2.gif",
                "cvvLength": 3,
                "validLengths": [12, 13, 14, 15, 16, 17, 18, 19],
                "binRanges": [
                    {
                        "min": "50"
                    },
                    {
                        "min": "56",
                        "max": "58"
                    },
                    {
                        "min": "639"
                    },
                    {
                        "min": "67"
                    }
                ]
            }
        ]
    },
    {
        "id": "AMEX",
        "icon": "https://images.gyft.com/ucomm/american_express_logo_2.gif",
        "cvvLength": 4,
        "validLengths": [15],
        "regex": "^(3[47][0-9]*)$"
    },
    {
        "id": "DISCOVER",
        "icon": "https://images.gyft.com/ucomm/discover_logo_2.gif",
        "cvvLength": 3,
        "validLengths": [16, 17, 18, 19],
        "binRanges": [
            {
                "min": "6011"
            },
            {
                "min": "64"
            },
            {
                "min": "65"
            }
        ]
    }/*,
    {
        "id": "DINNERS_CLUB_INTERNATIONAL",
        "icon": "https://images.gyft.com/ucomm/discover_logo_2.gif",
        "cvvLength": 3,
        "validLengths": [14, 15, 16, 17, 18, 19],
        "binRanges": [
            {
                "min": "36"
            }
        ]
    },
    {
        "id": "DINNERS_CLUB_INTERNATIONAL_2",
        "icon": "https://images.gyft.com/ucomm/discover_logo_2.gif",
        "cvvLength": 3,
        "validLengths": [16, 17, 18, 19],
        "binRanges": [
            {
                "min": "300",
                "max": "305"
            },
            {
                "min": "3095"
            },
            {
                "min": "38",
                "max": "39"
            }
        ]
    },
    {
        "id": "JCB",
        "icon": "https://images.gyft.com/ucomm/discover_logo_2.gif",
        "cvvLength": 3,
        "validLengths": [16, 17, 18, 19],
        "binRanges": [
            {
                "min": "3528",
                "max": "3589"
            }
        ]
    },
    {
        "id": "DANKORT",
        "icon": "https://images.gyft.com/ucomm/discover_logo_2.gif",
        "cvvLength": 3,
        "validLengths": [16],
        "binRanges": [
            {
                "min": "5019"
            }
        ]
    }*/
];

export  const MONTHS = [
    {"value": "01", "display": "1-Jan"},
    {"value": "02", "display": "2-Feb"},
    {"value": "03", "display": "3-Mar"},
    {"value": "04", "display": "4-Apr"},
    {"value": "05", "display": "5-May"},
    {"value": "06", "display": "6-Jun"},
    {"value": "07", "display": "7-Jul"},
    {"value": "08", "display": "8-Aug"},
    {"value": "09", "display": "9-Sept"},
    {"value": "10", "display": "10-Oct"},
    {"value": "11", "display": "11-Nov"},
    {"value": "12", "display": "12-Dec"}
];

export const MONTHS_NAME = {
    "month.1.label": "1-Jan",
    "month.2.label": "2-Feb",
    "month.3.label": "3-Mar",
    "month.4.label": "4-Apr",
    "month.5.label": "5-May",
    "month.6.label": "6-Jun",
    "month.7.label": "7-Jul",
    "month.8.label": "8-Aug",
    "month.9.label": "9-Sept",
    "month.10.label": "10-Oct",
    "month.11.label": "11-Nov",
    "month.12.label": "12-Dec",
}